module.exports = __webpack_public_path__ + "static/media/shopify8.e3646013.png";